const EARTH_RADIUS = 6378137;
const toRadians = (degrees) => (degrees * Math.PI) / 180;
const toDegrees = (radians) => (radians * 180) / Math.PI;
export const getBoundsFromCircle = (center, radiusInMeters) => {
    const { latitude, longitude } = center;
    const latOffset = radiusInMeters / EARTH_RADIUS;
    const lngOffset = radiusInMeters / (EARTH_RADIUS * Math.cos(toRadians(latitude)));
    return {
        north: latitude + toDegrees(latOffset),
        south: latitude - toDegrees(latOffset),
        east: longitude + toDegrees(lngOffset),
        west: longitude - toDegrees(lngOffset),
    };
};
